import { connectMonthListItem } from './connectMonthListItem';
import { MonthListItem as MonthListItemPure } from './MonthListItem';

export const MonthListItem = connectMonthListItem(MonthListItemPure);
